/* eslint-disable react-hooks/exhaustive-deps */
import { useQuery } from '@tanstack/react-query';
import { getLiveAccount } from 'api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import baseLogger from '~logger';

const logger = baseLogger.child('useGetAccount');

export const useEventAccount = () => {
  const { eventId: eventIdParam, eventAccount: eventAccountParam } =
    useParams();
  const [eventId, setEventId] = useState<string>();
  const [eventAccount, setEventAccount] = useState<string>();

  const { refetch } = useQuery(
    ['live-account'],
    () => getLiveAccount(eventIdParam!),
    { enabled: false },
  );

  const fetchLiveAccount = async () => {
    try {
      const { data } = await refetch();
      setEventId(eventIdParam);
      setEventAccount(data?.account);
    } catch (err) {
      logger.error('Error in fetchLiveAccount:', err);
    }
  };

  useEffect(() => {
    if (eventAccountParam === 'account') {
      fetchLiveAccount();
    } else {
      setEventId(eventIdParam);
      setEventAccount(eventAccountParam);
    }
  }, []);

  return { eventId, eventAccount, eventAccountParam };
};
